import { useContext } from 'react';

import type { PasswordRecoveryWizardData } from '@swf/auth';
import { DataContext } from '@swf/components/StarsWizard/StarsWizard';
import type { FirstWizardData, FirstWizardValues } from '@swf/first';

import type { WizardContext } from '../types/Wizard';

type WizardData = FirstWizardData & PasswordRecoveryWizardData;

const useWizardContext = <D = WizardData, V = FirstWizardValues>(): WizardContext<D, V> =>
  useContext<WizardContext<D, V>>(DataContext);

export default useWizardContext;
